
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class H5App extends Vue {
  mounted() {
    // 检测是否为移动端
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    if (isMobile) {
      console.log('H5 应用已加载 - 移动端')
    }
  }
}
